module.exports = __webpack_public_path__ + "img/googlewhite.73a41e6f.svg";